import {cva} from 'class-variance-authority';

export const badgeVariants = cva(
  'inline-flex items-center rounded-full border transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        filled: '',
        outlined: '',
      },
      color: {
        neutral: '',
        primary: '',
        secondary: '',
        accent: '',
        success: '',
        info: '',
        warning: '',
        danger: '',
        dark: '',
      },
      size: {
        default: 'gap-1 px-3 py-1 text-xs font-normal',
        small: 'gap-1 px-3 py-1 text-xs font-normal',
        medium:
          'gap-1.5 px-3 py-1 font-urbanist text-base font-medium tracking-[-0.32px]',
        large:
          'gap-2 px-4 py-1 font-urbanist text-lg font-medium tracking-[-0.54px]',
      },
    },
    compoundVariants: [
      // filled
      {
        variant: 'filled',
        color: 'neutral',
        class: 'border-transparent bg-neutral-100 text-neutral-800',
      },
      {
        variant: 'filled',
        color: 'primary',
        class: 'border-transparent bg-primary-700 text-white',
      },
      {
        variant: 'filled',
        color: 'secondary',
        class: 'border-transparent bg-secondary-700 text-white',
      },
      {
        variant: 'filled',
        color: 'accent',
        class: 'border-transparent bg-accent-500 text-accent-950',
      },
      {
        variant: 'filled',
        color: 'success',
        class: 'border-transparent bg-primary-500 text-white',
      },
      {
        variant: 'filled',
        color: 'info',
        class: 'border-transparent bg-info-500 text-white',
      },
      {
        variant: 'filled',
        color: 'warning',
        class: 'border-transparent bg-warning-500 text-white',
      },
      {
        variant: 'filled',
        color: 'danger',
        class: 'border-transparent bg-danger-500 text-white',
      },
      {
        variant: 'filled',
        color: 'dark',
        class: 'border-transparent bg-primary-800 text-white',
      },
      // outlined
      {
        variant: 'outlined',
        color: 'neutral',
        class: 'border-neutral-800 bg-neutral-50 text-neutral-800',
      },
      {
        variant: 'outlined',
        color: 'primary',
        class: 'border-primary-700 bg-primary-50 text-primary-700',
      },
      {
        variant: 'outlined',
        color: 'secondary',
        class: 'border-secondary-700 bg-secondary-50 text-secondary-700',
      },
      {
        variant: 'outlined',
        color: 'accent',
        class: 'border-accent-500 bg-accent-50 text-accent-900',
      },
      {
        variant: 'outlined',
        color: 'success',
        class: 'border-primary-500 bg-primary-50 text-primary-800',
      },
      {
        variant: 'outlined',
        color: 'info',
        class: 'border-info-600 bg-info-50 text-info-700',
      },
      {
        variant: 'outlined',
        color: 'warning',
        class: 'border-warning-500 bg-warning-50 text-warning-800',
      },
      {
        variant: 'outlined',
        color: 'danger',
        class: 'border-danger-500 bg-danger-50 text-danger-700',
      },
      {
        variant: 'outlined',
        color: 'dark',
        class: 'border-primary-800 bg-primary-50 text-primary-800',
      },
    ],
    defaultVariants: {
      variant: 'filled',
      color: 'neutral',
      size: 'default',
    },
  }
);
